import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';
import HeaderSection from '../../../../components/MenuManager/Header/Section';
import Utils from '../../../../utils';
import RoutesUtils from '../../../../utils/routes';
import { RoutePath } from '../../../../routes/constants';

const mapStateToProps = ({
	driveList,
	appInfos,
	galleryInfos: { config },
	sharePanel,
	search,
	routerParamsHistory,
	profile,
}: StoreState) => {
	const privateDirId = Utils.getPrivateDirId(driveList, config);
	const sharedDirId = Utils.getSharedDirId(driveList, config);
	const currentRoute = RoutesUtils.getCurrentRoute(routerParamsHistory);
	const isSettingsPage = [
		RoutePath.ParametersPage,
		RoutePath.ProfilePage,
	].includes(currentRoute);

	return {
		privateDirId,
		sharedDirId,
		isButtonCreateAvailable: Utils.isMultiApp(appInfos) &&
			profile.role &&
			!Utils.isReadOnlyApp(profile.role) &&
			!!privateDirId &&
			!sharePanel.isOpen &&
			!search.isShown &&
			!isSettingsPage,
	};
};

export default connect(mapStateToProps)(HeaderSection);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MenuManager/Header/Section/index.ts